module.exports = (__webpack_require__(14))(295);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference obpa_dependencies
// module id = 76
// module chunks = 0